export default "__VITE_PUBLIC_ASSET__caad8076__"